export default __webpack_public_path__ + "static/media/cocktail6.aaf5ba4d.jpg";